import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { string, bool } from 'prop-types'

// Components
import { Text, If, ExternalLinkButton } from 'src/Components'
import { IconAngleRight } from 'src/Components/shared/Icon'

// Styles
import baseStyles from '../ListingsCarousel.module.scss'
import styles from './AdSlide.module.scss'

const AdSlide = ({ id, url, includeFullAd, className }) => (
  <ExternalLinkButton
    key={id}
    className={classnames(
      baseStyles.buttonParent,
      styles.adSlideContainer,
      className
    )}
    href={url}
  >
    <div className={styles.adImageContainer} />
    <div className={styles.adDataContainer}>
      <Text size='xl' weight='bold' variant='neutralCool' variantCount='900'>
        <FormattedMessage
          id='Listings.ad.header'
          defaultMessage='Buying smart?'
        />
      </Text>
      <If condition={includeFullAd}>
        <Text
          size='xs'
          variant='neutralCool'
          variantCount='700'
          className={styles.fullAd}
        >
          <FormattedMessage
            id='Listings.ad.subheader.full.ad'
            defaultMessage='Supercharge your house hunting with smart insights on other search sites'
          />
        </Text>
        <Text
          size='xxs'
          variant='secondary'
          variantCount='600'
          className={styles.getChromebotText}
        >
          <FormattedMessage
            id='Listings.ad.subheader.full.ad.link'
            defaultMessage='Get Homebot for Chrome'
          />
          <IconAngleRight className={styles.adIcon} />
        </Text>
      </If>
      <If condition={!includeFullAd}>
        <Text
          size='xxs'
          variant='secondary'
          variantCount='600'
          className={styles.baseAdText}
        >
          <FormattedMessage
            id='Listings.ad.subheader'
            defaultMessage='Learn about Homebot for Chrome'
          />
        </Text>
      </If>
    </div>
  </ExternalLinkButton>
)

AdSlide.propTypes = {
  id: string,
  url: string,
  includeFullAd: bool,
  className: string,
}

AdSlide.defaultProps = {
  includeFullAd: false,
}

export default AdSlide
